import ItemAccountForm from "../../../components/AccountComponents/ItemAccountForm";

function NewItemAccountPage(){
    return(<ItemAccountForm method="post"  title="Category"/>)
}


export default NewItemAccountPage;